<template>
    <div v-click-outside="onclickOutside">
        <button 
            @click="toggleShowNotificationsMenu" 
            class="cursor-pointer py-2 px-1 rounded-lg focus:ring-1 focus:ring-gray-300 dark:focus:ring-gray-600 hover:bg-gray-100">
            <font-awesome-icon icon="fa-solid fa-bell" class="h-5 w-8 text-gray-500" />
        </button>
        <div
            class="z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600 "
            :class="{'absolute top-14 right-48': showNotificationsMenu, 'hidden': !showNotificationsMenu}">
            
            <ul class="py-4 px-20" role="none">
                <li class="font-semibold text-sm">
                    Sin notificaciones.
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import vClickOutside from 'click-outside-vue3'
    
    export default {
        directives: {
        clickOutside: vClickOutside.directive,
    },
        setup() {
            const showNotificationsMenu = ref(false)

            return {
                showNotificationsMenu,
                toggleShowNotificationsMenu: () => {
                    showNotificationsMenu.value = !showNotificationsMenu.value
                },
                onclickOutside: () => {
                    showNotificationsMenu.value = false
                }
            }
        },
    }
</script>